var map = {
	"./center.js": "cJhG",
	"./index.js": "8NmS",
	"./person.js": "qqEH",
	"./team.js": "iCAz",
	"./travel.js": "asSC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyiS";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules \.js$
// module id = kyiS
// module chunks = 24